import { createFileRoute } from '@tanstack/react-router';

import { FEATURE_FLAGS } from 'shared/consts';
import { revalidateLocationCapabilities } from 'shared/modules/capabilities';
import { routes } from 'shared/routes';
import { requireFeatureFlag } from 'shared/utils';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/reviews/manager')({
  staticData: { breadcrumb: 'reviewManager' },
  beforeLoad: ({ context }) =>
    requireFeatureFlag(FEATURE_FLAGS.REVIEW_MANAGER_ALLOWED, context.authUser.featureAllowance, {
      fallbackRoute: routes.locations()
    }),
  // The pages' gate reads the location capabilities; refreshing them here keeps the pages from rendering
  // empty or from stale access first.
  loader: ({ context: { queryClient }, params: { id } }) =>
    revalidateLocationCapabilities({ queryClient, locationId: id })
});
